import { useQuery } from 'react-query';
import { User, UsersResponse } from './userTypes';
import { getUsers } from './userService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: UsersResponse) => void;
    mapper?: (data?: UsersResponse) => M | User[] | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: UsersResponse) => data;

export const useGetUsers = <M = UsersResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<UsersResponse, Error>(['users'], getUsers, {
        onSuccess,
        onError,
        enabled: enabled,
    });

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
